import { Sidebar } from "./sidebar";
import { Header } from "./header";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  
  return (
    <div className="flex h-screen bg-slate-50 dark:bg-slate-900 overflow-hidden w-full">
      {/* Fixed Sidebar - Always visible for authenticated users */}
      <div className="w-64 flex-shrink-0 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 z-10 overflow-y-auto">
        <Sidebar />
      </div>
      {/* Main Content Area - Full width */}
      <main className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header />
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="p-6 w-full">
            <div className="max-w-7xl mx-auto w-full">
              {children}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}